import { countFormatSlots, getPhoneDigits } from '../../utils';

import type { Country } from '../../../model';

/** Отрезаем лишнее, чтобы в маску попали только цифры номера без кода страны. */
export const stripExtraPhoneDigits = (digits: string, country: Country): string => {
  const slotCount = countFormatSlots(country.format);

  if (digits.length <= slotCount) {
    return digits;
  }

  const overflow = digits.length - slotCount;
  const dialCodeDigits = getPhoneDigits(country.dialCode);

  if (dialCodeDigits && digits.startsWith(dialCodeDigits) && overflow === dialCodeDigits.length) {
    return digits.slice(dialCodeDigits.length);
  }

  // 8 в начале — тот же +7
  if (dialCodeDigits === '7' && digits.startsWith('8') && overflow === 1) {
    return digits.slice(1);
  }

  // префикс не узнали — оставляем последние цифры под маску
  return digits.slice(-slotCount);
};
